import { render } from "./AddQuartierModal.vue?vue&type=template&id=d279ff76&ts=true"
import script from "./AddQuartierModal.vue?vue&type=script&lang=ts"
export * from "./AddQuartierModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__